import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import indicatorEnumerators from 'src/modules/indicator/indicatorEnumerators';

export default [
  {
    name: 'name',
    label: i18n('entities.indicator.fields.name'),
    schema: schemas.string(
      i18n('entities.indicator.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'periodicity',
    label: i18n('entities.indicator.fields.periodicity'),
    schema: schemas.enumerator(
      i18n('entities.indicator.fields.periodicity'),
      {
        "required": true,
        "options": indicatorEnumerators.periodicity
      },
    ),
  },
  {
    name: 'year',
    label: i18n('entities.indicator.fields.year'),
    schema: schemas.integer(
      i18n('entities.indicator.fields.year'),
      {},
    ),
  },
  {
    name: 'entityType',
    label: i18n('entities.indicator.fields.entityType'),
    schema: schemas.enumerator(
      i18n('entities.indicator.fields.entityType'),
      {
        "options": indicatorEnumerators.entityType
      },
    ),
  },
  {
    name: 'locationEntity',
    label: i18n('entities.indicator.fields.locationEntity'),
    schema: schemas.relationToMany(
      i18n('entities.indicator.fields.locationEntity'),
      {},
    ),
  },
  {
    name: 'assetEntity',
    label: i18n('entities.indicator.fields.assetEntity'),
    schema: schemas.relationToMany(
      i18n('entities.indicator.fields.assetEntity'),
      {},
    ),
  },
  {
    name: 'appUser',
    label: i18n('entities.indicator.fields.appUser'),
    schema: schemas.relationToMany(
      i18n('entities.indicator.fields.appUser'),
      {},
    ),
  },
  {
    name: 'formCategoryEntity',
    label: i18n('entities.indicator.fields.formCategoryEntity'),
    schema: schemas.relationToMany(
      i18n('entities.indicator.fields.formCategoryEntity'),
      {},
    ),
  },
  {
    name: 'formTemplateEntity',
    label: i18n('entities.indicator.fields.formTemplateEntity'),
    schema: schemas.relationToMany(
      i18n('entities.indicator.fields.formTemplateEntity'),
      {},
    ),
  },
  {
    name: 'quantity',
    label: i18n('entities.indicator.fields.quantity'),
    schema: schemas.integer(
      i18n('entities.indicator.fields.quantity'),
      {},
    ),
  },
  {
    name: 'indicator',
    label: i18n('entities.indicator.fields.indicator'),
    schema: schemas.enumerator(
      i18n('entities.indicator.fields.indicator'),
      {
        "options": indicatorEnumerators.indicator
      },
    ),
  },
  {
    name: 'attachments',
    label: i18n('entities.indicator.fields.attachments'),
    schema: schemas.files(
      i18n('entities.indicator.fields.attachments'),
      {},
    ),
  },
];